/* Bibelle — comportements d'interface.
   Un seul fichier pour toutes les pages : chaque bloc sort si son element
   n'existe pas, donc l'accueil ignore ce qui ne concerne que la fiche. */

(function () {
  'use strict';

  /* Retour arriere depuis le paiement. Le navigateur ne redemande pas la
     page : il restitue celle qu'il gardait en memoire, avec ses prix et ses
     identifiants de variante d'alors. Ce cache-la ignore cache-control par
     construction. Sur une boutique, c'est inacceptable — un client pourrait
     ajouter au panier une variante qui n'existe plus, ou lire un prix qui a
     change. On redemande la page au serveur.

     e.persisted n'est vrai que sur une vraie restitution memoire : pas de
     boucle de rechargement a craindre. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.location.reload();
  });

  /* Compte a rebours du prix de lancement.
     Il vise une date fixe, identique pour tout le monde : pas de minuterie
     remise a zero a chaque visite, ce serait une urgence fabriquee. Une fois
     l'echeance passee, le bandeau entier disparait — mieux vaut plus rien
     qu'une date perimee laissee a l'ecran. */
  (function compteARebours() {
    var el = document.getElementById('bbCompte');
    if (!el) return;

    var fin = Date.parse(el.dataset.bbFin);
    if (isNaN(fin)) return;

    var bandeau = document.getElementById('bbLancement');

    function deux(n) { return n < 10 ? '0' + n : '' + n; }

    function rendre() {
      var reste = fin - Date.now();

      if (reste <= 0) {
        if (bandeau) bandeau.hidden = true;
        clearInterval(battement);
        return;
      }

      var j = Math.floor(reste / 86400000);
      var h = Math.floor(reste / 3600000) % 24;
      var m = Math.floor(reste / 60000) % 60;
      var s = Math.floor(reste / 1000) % 60;

      el.textContent = (j > 0 ? j + ' j ' : '') + deux(h) + ' h ' + deux(m) + ' min ' + deux(s) + ' s';
      el.hidden = false;
    }

    var battement = setInterval(rendre, 1000);
    rendre();
  })();

  /* En-tete : masquee quand on descend, revelee des qu'on remonte.
     Le seuil de 6 px evite qu'un tremblement de trackpad la fasse clignoter ;
     celui de 160 px la laisse tranquille en haut de page. */
  (function enTete() {
    var bar = document.getElementById('headbar');
    if (!bar) return;

    var dernier = window.scrollY;

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      bar.classList.toggle('is-stuck', y > 4);

      if (Math.abs(y - dernier) < 6) return;
      bar.classList.toggle('is-hidden', y > dernier && y > 160);
      dernier = y;
    }, { passive: true });
  })();

  /* Galerie : vignettes en une ligne, fleches sur la grande image.
     Les adresses Shopify portent la largeur en parametre, impossible de la
     deviner depuis la miniature : chaque vignette transporte donc la sienne. */
  var galerie = (function () {
    var piste = document.getElementById('galleryThumbs');
    var principale = document.getElementById('galleryMain');
    var defile = document.getElementById('galleryTrack');
    if (!piste || !principale || !defile) return null;

    var courant = 0;
    var vignettes = [];
    var vues = new Map();

    /* Une vue par vignette, creee a la demande et gardee : la deplacer dans
       la piste ne recharge pas son image. La vue deja rendue par Liquid est
       rattachee a la vignette affichee au chargement. */
    var depart = piste.querySelector('button[aria-current="true"]') || piste.querySelector('button');
    if (depart) vues.set(depart, principale.parentNode);

    function vue(b) {
      var v = vues.get(b);
      if (v) return v;
      v = document.createElement('div');
      v.className = 'bb-gallery__slide';
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.sizes = principale.sizes;
      img.srcset = b.dataset.srcset || '';
      img.src = b.dataset.full;
      img.alt = b.dataset.alt || '';
      v.appendChild(img);
      vues.set(b, v);
      return v;
    }

    function recenser() {
      vignettes = Array.prototype.slice.call(piste.querySelectorAll('button:not([hidden])'));
      defile.replaceChildren.apply(defile, vignettes.map(vue));
    }

    recenser();
    if (!vignettes.length) return null;
    courant = Math.max(0, vignettes.indexOf(depart));
    if (courant) montrer(courant, true);

    function centrer(bouton) {
      var marge = (piste.clientWidth - bouton.offsetWidth) / 2;
      piste.scrollTo({ left: Math.max(0, bouton.offsetLeft - marge), behavior: 'smooth' });
    }

    function marquer(i) {
      courant = i;
      vignettes.forEach(function (o, j) { o.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      centrer(vignettes[i]);
    }

    function montrer(i, instantane) {
      i = (i + vignettes.length) % vignettes.length;
      marquer(i);
      defile.scrollTo({ left: i * defile.clientWidth, behavior: instantane ? 'auto' : 'smooth' });
    }

    /* Le doigt fait defiler la piste nativement : on se contente de suivre
       la vue calee pour garder la vignette active en phase. */
    var attente = 0;
    defile.addEventListener('scroll', function () {
      if (attente) return;
      attente = requestAnimationFrame(function () {
        attente = 0;
        var i = Math.round(defile.scrollLeft / defile.clientWidth);
        if (i !== courant && vignettes[i]) marquer(i);
      });
    }, { passive: true });

    /* Clic delegue : l'index d'une vignette change quand on en montre ou
       qu'on en cache, un indice fige a la pose de l'ecouteur deviendrait faux. */
    piste.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var i = vignettes.indexOf(b);
      if (i >= 0) montrer(i);
    });

    document.querySelectorAll('[data-bb-step]').forEach(function (fleche) {
      /* data-bb-step se lit dataset.bbStep : ecrit dataset.step, on recuperait
         undefined, donc NaN, donc un index hors tableau et un clic sans effet. */
      var pas = parseInt(fleche.dataset.bbStep, 10);
      if (isNaN(pas)) return;
      fleche.addEventListener('click', function () { montrer(courant + pas); });
    });

    /* Une piste redimensionnee garde son scrollLeft en pixels : sans recalage,
       elle s'arreterait a cheval entre deux vues. */
    window.addEventListener('resize', function () { montrer(courant, true); });

    return {
      /* Les coloris partagent une seule vignette, en tete : changer de coloris
         la reecrit sur place au lieu d'allonger le carrousel. */
      majColoris: function (variante) {
        var b = piste.querySelector('[data-bb-variant-slot]');
        if (!b || !variante.image) return;

        b.dataset.full = variante.image;
        b.dataset.srcset = variante.srcset || '';
        b.dataset.alt = variante.alt || '';

        var img = b.querySelector('img');
        if (img) {
          img.srcset = '';
          img.src = variante.vignette || variante.image;
          img.alt = variante.alt || '';
        }

        /* srcset d'abord : tant qu'il est renseigne, le navigateur l'utilise
           et ignore purement et simplement le src qu'on vient de changer. */
        var grande = vue(b).querySelector('img');
        grande.srcset = b.dataset.srcset;
        grande.src = b.dataset.full;
        grande.alt = b.dataset.alt;

        montrer(vignettes.indexOf(b));
      }
    };
  })();

  /* Coloris : choisir une pastille change reellement la variante ajoutee au
     panier, pas seulement le libelle. Sans cela, selectionner Noir commandait
     du Gris. */
  (function coloris() {
    var source = document.getElementById('bbVariants');
    var champ = document.getElementById('bbVariantId');
    var listes = document.querySelectorAll('.bb-swatches, .bb-bundles');
    if (!source || !champ || !listes.length) return;

    var variantes;
    try { variantes = JSON.parse(source.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var cta = document.getElementById('bbCta');
    var ctaCollant = document.getElementById('bbStickyCta');

    function choix() {
      var valeurs = [];
      listes.forEach(function (liste) {
        var actif = liste.querySelector('button[aria-pressed="true"]');
        if (!actif) return;
        valeurs[parseInt(actif.dataset.option, 10) - 1] = actif.dataset.name;
      });
      return valeurs;
    }

    function ecrire(id, texte) {
      var el = document.getElementById(id);
      if (el) el.textContent = texte;
    }

    function majPrixFormules(valeurs) {
      var cartes = document.querySelectorAll('.bb-bundles button');
      if (!cartes.length) return;

      cartes.forEach(function (carte) {
        var rang = parseInt(carte.dataset.option, 10) - 1;

        var candidate = variantes.filter(function (vr) {
          return valeurs.every(function (val, i) {
            return i === rang ? true : vr.options[i] === val;
          }) && vr.options[rang] === carte.dataset.name;
        })[0];
        if (!candidate) return;

        carte.querySelectorAll('[data-bb-prix-formule]').forEach(function (el) {
          el.textContent = candidate.prix;
        });
      });
    }

    function appliquer() {
      var valeurs = choix();

      var variante = variantes.filter(function (v) {
        return valeurs.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (!variante) return;

      champ.value = variante.id;
      ecrire('bbPrice', variante.prix);

      /* Le prix barre suit la formule : sans cela, choisir le lot complet
         laissait a l'ecran le barre du sac seul. */
      ['bbCompare', 'stickyCompare'].forEach(function (id) {
        var barre = document.getElementById(id);
        if (!barre) return;
        barre.textContent = variante.barre || '';
        barre.hidden = !variante.barre;
      });

      ['bbRemise', 'stickyRemise'].forEach(function (id) {
        var remise = document.getElementById(id);
        if (!remise) return;
        remise.textContent = variante.remise > 0 ? '-' + variante.remise + ' %' : '';
        remise.hidden = !(variante.remise > 0);
      });

      ecrire('stickyPrice', variante.prix);
      ecrire('stickyCtaPrice', variante.prix);

      [cta, ctaCollant].forEach(function (b) {
        if (!b) return;
        b.disabled = !variante.dispo;
      });
      if (cta) cta.textContent = variante.dispo ? 'Ajouter au panier' : 'Épuisé';

      if (galerie) galerie.majColoris(variante);
      majPrixFormules(valeurs);

      /* L'adresse suit la selection : un lien copie-colle rouvre le bon coloris. */
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        history.replaceState({}, '', url);
      }
    }

    listes.forEach(function (liste) {
      liste.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          liste.querySelectorAll('button').forEach(function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          b.setAttribute('aria-pressed', 'true');

          var etiquette = document.querySelector('[data-bb-option-name="' + b.dataset.option + '"]');
          if (etiquette) etiquette.textContent = b.dataset.name;

          appliquer();
        });
      });
    });
  })();

  /* Supplements : deux cases a cocher a la place de quatre formules pleines.
     Les cases ne connaissent ni prix ni variante. Elles designent la formule
     qui correspond a leur etat et la cliquent : toute la resolution de
     variante reste a un seul endroit, dans coloris(). */
  (function supplements() {
    var panneau = document.getElementById('bbAddons');
    var liste = document.querySelector('.bb-bundles');
    if (!panneau || !liste) return;

    var formules = Array.prototype.slice.call(liste.querySelectorAll('button'));
    var cases = Array.prototype.slice.call(panneau.querySelectorAll('input[data-bb-cle]'));
    if (!formules.length || !cases.length) return;

    /* L'echange n'a lieu qu'ici : sans script, la liste des quatre formules
       reste affichee et reste utilisable. */
    liste.hidden = true;
    panneau.hidden = false;

    function signature(cles) {
      return cles.slice().sort().join('|');
    }

    function cochees() {
      return cases.filter(function (c) { return c.checked; })
                  .map(function (c) { return c.dataset.bbCle; });
    }

    /* Le panier ne voit qu'une ligne : une seule variante porte le sac et ses
       articles joints. La propriete de ligne dit lesquels, et a quel
       supplement, pour que le tiroir puisse en detailler le contenu. Elle est
       d'affichage seulement — le prix reellement facture reste celui de la
       variante, que le client ne peut pas toucher. */
    var champ_inclus = document.getElementById('bbInclus');
    var ancre = document.getElementById('bbAncre');

    /* Ce que les memes articles couteraient pris a l'unite. Le texte est
       compose en Liquid et transporte par la formule : le navigateur n'a pas
       a savoir formater une devise. */
    function majAncre() {
      if (!ancre) return;
      var presse = liste.querySelector('button[aria-pressed="true"]');
      var texte = (presse && presse.dataset.ancre) || '';
      ancre.textContent = texte;
      ancre.hidden = texte === '';
    }

    function majInclus() {
      if (!champ_inclus) return;
      champ_inclus.value = cases.filter(function (c) { return c.checked; })
        .map(function (c) { return c.dataset.bbCle + '~' + (c.dataset.bbSup || '0'); })
        .join('|');
    }

    /* Etat de depart : les cases refletent la formule deja selectionnee. */
    var presse = liste.querySelector('button[aria-pressed="true"]');
    var depart = ((presse && presse.dataset.cles) || '').split('|').filter(Boolean);
    cases.forEach(function (c) { c.checked = depart.indexOf(c.dataset.bbCle) !== -1; });
    majInclus();
    majAncre();

    panneau.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-bb-cle]')) return;

      var cles = cochees();
      var cible = signature(cles);

      var formule = formules.filter(function (b) {
        return signature((b.dataset.cles || '').split('|').filter(Boolean)) === cible;
      })[0];

      /* Aucune formule ne correspond a cette combinaison : on refuse la coche
         plutot que d'envoyer au panier une variante qui ne contient pas ce
         que la case annonce. */
      if (!formule) { e.target.checked = !e.target.checked; return; }

      formule.click();
      majInclus();
    majAncre();
    });
  })();

  /* Barre d'achat : elle n'apparait qu'une fois le bouton principal sorti par
     le HAUT. Tant qu'il est a l'ecran, ou encore plus bas, deux boutons
     identiques se feraient concurrence. */
  (function barreAchat() {
    var cta = document.getElementById('bbCta');
    var bar = document.getElementById('stickybuy');
    if (!cta || !bar) return;

    /* La place est reservee en permanence : la barre ne recouvre donc jamais
       la derniere ligne du pied de page quand elle se montre. */
    document.body.classList.add('bb-has-stickybuy');

    function verifier() {
      bar.classList.toggle('is-visible', cta.getBoundingClientRect().bottom < 0);
    }

    window.addEventListener('scroll', verifier, { passive: true });
    window.addEventListener('resize', verifier);
    verifier();
  })();

  /* Panier : tiroir lateral.
     Le contenu n'est jamais fabrique ici. Apres chaque modification on
     redemande la section a Shopify et on remplace le bloc : prix, totaux et
     remises restent calcules par Liquid, une seule fois, au bon endroit.
     Tout echec retombe sur la navigation normale vers /cart, qui fonctionne
     sans une ligne de script. */
  (function panier() {
    var hote = document.getElementById('shopify-section-bibelle-cart-drawer');
    if (!hote || !window.fetch || !window.DOMParser) return;

    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function ouvrir() { document.body.classList.add('bb-cart-open'); }
    function fermer() { document.body.classList.remove('bb-cart-open'); }

    /* La pastille de l'en-tete n'existe pas quand le panier est vide : elle
       est donc creee au besoin, pas seulement mise a jour. */
    function majCompteur() {
      var tiroir = hote.querySelector('#cartDrawer');
      var lien = document.querySelector('.bb-header__cart');
      if (!tiroir || !lien) return;

      var n = parseInt(tiroir.dataset.count, 10) || 0;
      var pastille = lien.querySelector('.bb-header__count');

      if (n === 0) {
        if (pastille) pastille.remove();
      } else {
        if (!pastille) {
          pastille = document.createElement('span');
          pastille.className = 'bb-header__count';
          lien.appendChild(pastille);
        }
        pastille.textContent = n;
      }
      lien.setAttribute('aria-label', 'Panier (' + n + ')');
    }

    /* Le fragment est analyse dans un document detache puis adopte tel quel.
       Passer par innerHTML sur un element vivant ferait executer au passage
       tout ce que la reponse contiendrait. */
    function rafraichir() {
      return fetch(window.location.pathname + '?sections=bibelle-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d['bibelle-cart-drawer'];
          if (!html) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.getElementById('shopify-section-bibelle-cart-drawer') || doc.body;
          hote.replaceChildren.apply(hote, Array.prototype.slice.call(neuf.childNodes));
          majCompteur();
        });
    }

    /* Un clic delegue sur l'hote et non sur le tiroir : le tiroir est remplace
       a chaque mise a jour, un ecouteur pose dessus disparaitrait avec lui. */
    hote.addEventListener('click', function (e) {
      if (e.target.closest('[data-bb-cart-close]')) { fermer(); return; }

      var bouton = e.target.closest('[data-bb-qty]');
      if (!bouton) return;

      var ligne = bouton.closest('[data-bb-key]');
      if (!ligne) return;

      bouton.disabled = true;
      fetch(racine + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: ligne.dataset.bbKey, quantity: parseInt(bouton.dataset.bbQty, 10) })
      })
        .then(rafraichir)
        .catch(function () { window.location.href = racine + 'cart'; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });

    /* L'icone de l'en-tete ouvre le tiroir au lieu de quitter la page. Le
       contenu affiche est celui rendu au chargement : on l'ouvre tout de
       suite, et on le rafraichit derriere pour le cas d'un autre onglet. */
    var lienPanier = document.querySelector('.bb-header__cart');
    if (lienPanier) {
      lienPanier.addEventListener('click', function (e) {
        e.preventDefault();
        ouvrir();
        rafraichir();
      });
    }

    var form = document.getElementById('bbForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var cta = document.getElementById('bbCta');
      var libelle = cta ? cta.textContent : '';
      if (cta) { cta.disabled = true; cta.textContent = 'Ajout en cours…'; }

      function rendre() {
        if (cta) { cta.disabled = false; cta.textContent = libelle; }
      }

      fetch(racine + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout refuse');
          return r.json();
        })
        .then(rafraichir)
        .then(function () { rendre(); ouvrir(); })
        .catch(function () {
          /* Rupture, erreur reseau, variante disparue : on laisse Shopify
             repondre sur sa propre page plutot que d'avaler l'echec. */
          rendre();
          form.submit();
        });
    });
  })();
})();
